<template>
    <div>
      <div class="wait">
        <div class="inline-block">
          <img  class="wait-img" src="../../../static/img/waiting.png" />
        </div>
        <div class="inline-block">
          <h6 >此功能暂未开放</h6>
        </div>
      </div>
      <!--<div class="subPage">-->

        <!--<img class="mssage-img" src="../../../static/img/empty.png" />-->
        <!--&lt;!&ndash; <div class="flex">-->
            <!--<p>隐藏已读</p>-->
            <!--<mt-switch v-model="value4" @change="handleChange" size="20"/>-->
        <!--</div> &ndash;&gt;-->
      <!--</div>-->
    </div>
</template>

<script>

export default {
  name: 'Message',
  meta:{page:true},
  data() {
    return {
        value: false,
    }
  },
  methods: {
      handleChange(value) {
          this.value = value;
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
	.subPage{
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	    width: 100%;
	    background-color: white;
	    min-height: 6.1rem;
	}
  .inline-block {
    display: inline-block;
  }
  .flex {
    display: flex;
  }
  .wait {
    background-color: #ffffff;
    margin: 17px;
    /*height: 167px;*/
    border-radius: 5px;
    padding-left: 24px;
    .wait-img {
      width: 32px;
      height: 32px;
      position: relative;
      top: 6px;
      padding-right: 15px;
    }
  }
	.mssage-img{
		/*margin-top: 50%;*/
	}
</style>



// WEBPACK FOOTER //
// src/components/page/Message.vue